
import { Component, Prop, Vue } from 'vue-property-decorator'
import CardRoundCtrl from '~/components/common/ctrls/CardRoundCtrl.vue'

@Component({
  name: 'CloseCrossCtrl',
  components: {
    CardRoundCtrl
  }
})
export default class CloseCrossCtrl extends Vue {
  @Prop({ type: Boolean, default: true }) isActive!: boolean
  @Prop({ type: String, default: '24px' }) iconSize!: string
  @Prop({ type: String, default: '28px' }) shapeSize!: string

  isClicked = false
  iconColor = {
    regular: this.$tokens.color_blue_bayoux,
    hover: this.$tokens.color_blue_bayoux,
    active: this.$tokens.color_blue_bayoux
  }

  shapeColor = {
    regular: this.$tokens.color_white,
    hover: this.$tokens.color_concrete,
    active: this.$tokens.color_onahau
  }
}
